<template>
  <div id="monitor">
    <van-divider>监考员信息管理</van-divider>
    <div class="m-4">
      <van-button
        @click="downloadFile(getMonitorFileUrl())"
        round
        size="small"
        class="w-100"
      >监考员名单-模板文件下载</van-button>
    </div>
    <el-form label-position="left" class="m-4 text-left">
      <div class="m-4">
        <van-row gutter="10">
          <van-col span="12">
            <el-upload
              :action="url"
              :headers="header"
              :data="param"
              :on-progress="handleProcess"
              :on-success="handleSuccess"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              :limit="9"
              :on-exceed="handleExceed"
              :show-file-list="false"
              multiple
            >
              <van-button type="primary" round class="w-100" size="small">上传监考人员名单</van-button>
            </el-upload>
          </van-col>
          <van-col span="12">
            <van-button type="info" class="w-100" size="small" round @click="sheet5=true">继承监考人员信息</van-button>
          </van-col>
        </van-row>
        <van-row class="mt-4">
          <van-col span="24">
            <van-button
              type="info"
              class="w-100"
              size="small"
              round
              @click="postMonitorDrawlotsmonitorBtn"
            >考场监考人员抽签</van-button>
          </van-col>
        </van-row>
        <van-row class="mt-4">
          <van-col span="24">
            <van-button
              type="info"
              class="w-100"
              size="small"
              round
              @click="moveMonitorDrawlotsmonitorBtn"
            >顺序调整抽签结果</van-button>
          </van-col>
        </van-row>
        <van-row class="mt-4">
          <van-col span="24">
            <van-button
              type="info"
              class="w-100"
              size="small"
              round
              @click="getMonirorReportBtn"
            >查看监考人员信息</van-button>
          </van-col>
        </van-row>
        <van-row class="mt-4">
          <van-col span="24">
            <!-- 监考员下载地址，获取地址时需要传考试和工作任务参数 -->
            <!-- <a
              :href="apiMonitorExportGet({WorkID: getWork().WorkID,SplitProcessID: SplitProcessID})"
              download="监考员信息.xls"
              target="_blank"
            >
              <van-button type="info" class="w-100" round size="normal">下载监考人员信息</van-button>
            </a>-->
            <van-button
              type="info"
              class="w-100"
              round
              size="small"
              @click="
                downloadFile(
                  apiMonitorExportGet({
                    WorkID: getWork().WorkID,
                    SplitProcessID: SplitProcessID
                  })
                )
              "
            >下载监考人员信息</van-button>
          </van-col>
        </van-row>
        <van-row class="mt-4" gutter="16">
          <van-col span="12">
            <van-button
              type="warning"
              class="w-100"
              size="small"
              round
              @click="deleteMonirorDrawlotsmonitorBtn"
            >清空现有抽签结果</van-button>
          </van-col>
          <van-col span="12">
            <van-button
              type="danger"
              class="w-100"
              size="small"
              round
              @click="deleteReportMonirorBtn"
            >删除监考员信息</van-button>
          </van-col>
        </van-row>
        <br />
      </div>
    </el-form>
    <!-- 选择表名 -->
    <van-popup
      v-model="sheet1"
      position="bottom"
      :style="{ width: '100%', height: '80%' }"
      closeable
      round
    >
      <van-nav-bar :title="'监考员信息表'" />
      <div class="m-4">
        <van-divider>点击下列表名选择</van-divider>
        <ul>
          <li
            v-for="(item, index) in sheet1content.TableList"
            :key="index"
            class="mt-4 color-blue"
            @click="getTableField(item)"
          >
            <i class="fa fa-fw fa-list"></i>
            {{ item }}
          </li>
        </ul>
      </div>
    </van-popup>
    <!-- 字段对应 -->
    <van-popup v-model="sheet2" position="bottom" class="popup-l1" closeable round>
      <van-nav-bar :title="'选择字段对应'" />
      <div class="m-4">
        <van-divider
          :style="{
            color: '#1989fa',
            borderColor: '#ffffff',
            padding: '0 16px'
          }"
        >
          <van-switch v-model="sheet2content.isDrawLots" size="20px" />
          <span
            class="ml-2 color-blue"
            v-if="sheet2content.isDrawLots"
            @click="sheet2content.isDrawLots = !sheet2content.isDrawLots"
          >通过系统在线抽签</span>
          <span
            class="ml-2 color-gray"
            v-else
            @click="sheet2content.isDrawLots = !sheet2content.isDrawLots"
          >不在系统内抽签</span>
        </van-divider>
        <el-form label-width="120px" v-show="!sheet2content.isDrawLots">
          <el-form-item label="考场">
            <template slot="label">
              <small>考场</small>
              <small class="color-gray">(可选)</small>
            </template>
            <el-select v-model="params.Fields.RoomNo" placeholder="选择考场名称" size="mini">
              <el-option v-for="item in sheet2content.data" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <small v-show="!sheet2content.isDrawLots" class="color-yellow">* 提示:不在系统内抽签需要对应考场信息</small>
        <van-divider>选择对应字段</van-divider>
        <el-form label-width="120px">
          <el-form-item label="监考员(必选)">
            <template slot="label">
              <small>监考员</small>
              <small class="color-yellow">(必选)</small>
            </template>
            <el-select v-model="params.Fields.UserName" placeholder="选择监考员姓名列名" size="mini">
              <el-option v-for="item in sheet2content.data" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form label-width="120px">
          <el-form-item label="身份证号(必选)">
            <template slot="label">
              <small>身份证号</small>
              <small class="color-yellow">(必选)</small>
            </template>
            <el-select v-model="params.Fields.UserPIN" placeholder="选择监考员身份证号" size="mini">
              <el-option v-for="item in sheet2content.data" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form label-width="120px">
          <el-form-item label="电话(可选)">
            <template slot="label">
              <small>电话</small>
              <small class="color-gray">(可选)</small>
            </template>
            <el-select v-model="params.Fields.Tel" placeholder="选择联系电话列名" size="mini">
              <el-option v-for="item in sheet2content.data" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form label-width="120px">
          <el-form-item label="抽签条件1(必选)">
            <template slot="label">
              <small>抽签条件1</small>
              <small
                :class="(params.Fields.RoomNo)?'color-gray':'color-yellow'"
              >{{(params.Fields.RoomNo)?'(可选)':'(必选)'}}</small>
            </template>
            <el-select v-model="params.Fields.UserType1" placeholder="选择首要抽签条件列名" size="mini">
              <el-option v-for="item in sheet2content.data" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form label-width="120px">
          <el-form-item label="抽签条件2(可选)">
            <template slot="label">
              <small>抽签条件2</small>
              <small class="color-gray">(可选)</small>
            </template>
            <el-select v-model="params.Fields.UserType2" placeholder="选择次要抽签条件列名" size="mini">
              <el-option v-for="item in sheet2content.data" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form label-width="120px">
          <el-form-item label="抽签条件3(可选)">
            <template slot="label">
              <small>抽签条件3</small>
              <small class="color-gray">(可选)</small>
            </template>
            <el-select v-model="params.Fields.UserType3" placeholder="选择第三抽签条件列名" size="mini">
              <el-option v-for="item in sheet2content.data" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div>
          <!-- <van-divider>后续场次继承监考员信息</van-divider> -->
          <van-radio-group v-model="params.RadRoomUser" direction="horizontal">
            <van-radio :name="0" class="p-2">
              <small>后续场次不继承</small>
            </van-radio>
            <van-radio :name="1" class="p-2">
              <small>后续场次继承监考名单</small>
            </van-radio>
          </van-radio-group>
        </div>
        <van-button
          hairline
          class="w-100 mt-4 mb-4"
          type="info"
          @click="setMonirorReportBtn"
        >导入监考人员信息</van-button>
      </div>
    </van-popup>
    <!-- 获取监考员信息 -->
    <van-popup v-model="sheet3" position="bottom" class="popup-l1" round closeable>
      <van-nav-bar title="监考员信息" />
      <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o">
        {{
        sheet3content.resultmessage
        }}
      </van-notice-bar>
      <div class="m-4">
        <van-divider>
          <!-- 监考员下载地址，获取地址时需要传考试和工作任务参数 -->
          <div>
            <van-button
              type="info"
              class="w-100"
              plain
              hairline
              size="small"
              @click="
                downloadFile(
                  apiMonitorExportGet({
                    WorkID: getWork().WorkID,
                    SplitProcessID: SplitProcessID
                  })
                )
              "
            >下载监考人员信息</van-button>
          </div>
        </van-divider>
        <van-cell-group class="text-left">
          <van-cell v-for="(item, index) in sheet3content.data" :key="index">
            <template slot="title">
              <span
                v-if="
                  index == 0 ||
                    sheet3content.data[index - 1].RoomNo != item.RoomNo
                "
                class="text-bold"
              >{{ item.RoomNo }}</span>
              <span v-else class="color-gray">{{ item.RoomNo }}</span>
              <span v-if="!item.RoomNo">流动</span>
            </template>
            <template slot="default">
              <small class="text color-black">
                {{ item.Name }}
                <small>
                  <a class="color-blue" :href="'tel:' + item.Tel">
                    {{
                    item.Tel
                    }}
                  </a>
                </small>
                <!-- <small>[{{ item.Tel }}]</small> -->
                <p>
                  <small>身份证号 [ {{ item.UserPIN }} ]</small>
                </p>
              </small>
            </template>
          </van-cell>
        </van-cell-group>
      </div>
    </van-popup>
    <!-- 按顺序调整抽签顺序 -->
    <van-popup v-model="sheet4" position="bottom" class="popup-l2" round closeable>
      <van-nav-bar title="按顺序调整抽签顺序" />

      <el-form ref="form" :model="sheet4content.data" label-width="110px" class="m-4">
        <el-form-item label="移动范围">
          <el-select v-model="sheet4content.data.AllMoveFlg" placeholder="请选择活动区域">
            <el-option label="全部移动" :value="1"></el-option>
            <el-option label="部分移动" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="起始考场号" v-show="sheet4content.data.AllMoveFlg == 0">
          <el-input v-model="sheet4content.data.StartRoomNo"></el-input>
        </el-form-item>
        <el-form-item label="终止考场号" v-show="sheet4content.data.AllMoveFlg == 0">
          <el-input v-model="sheet4content.data.EndRoomNo"></el-input>
        </el-form-item>
        <el-form-item label="移动方向">
          <el-select v-model="sheet4content.data.MoveUpOrDownFlg" placeholder="请选择活动区域">
            <el-option label="向前调整" :value="1"></el-option>
            <el-option label="向后调整" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="移动的位数">
          <el-input v-model="sheet4content.data.MoveNumber"></el-input>
        </el-form-item>
        <el-button type="primary" @click="moveMonitorDrawlotsmonitorHandleBtn">执行顺序调整</el-button>
      </el-form>
    </van-popup>
    <!-- 继承监考人员信息 -->
    <van-popup v-model="sheet5" :style="{'width':'80%','height':'35%'}" round closeable>
      <van-nav-bar title="请选择继承方式" />
      <p>继承上一场监考员信息的</p>
      <van-button type="default" class="w-75" @click="putMonitorDrawlotsmonitorBtn(2)">仅继承监考名单</van-button>
      <p>或</p>
      <van-button type="primary" class="w-75" @click="putMonitorDrawlotsmonitorBtn(1)">名单及抽签结果</van-button>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "monitor",
  data() {
    return {
      sheet1: false,
      sheet1content: {
        FileID: "",
        TableList: [],
        TableName: ""
      },
      sheet2: false,
      sheet2content: {
        isDrawLots: true, //是否在系统内抽签开关变量
        data: []
      },
      sheet3: false,
      sheet3content: {
        data: [],
        resultmessage: ""
      },
      sheet4: false,
      sheet4content: {
        data: {
          WorkID: this.getWork().WorkID,
          SplitProcessID: this.SplitProcessID,
          AllMoveFlg: 1,
          MoveUpOrDownFlg: 0,
          MoveNumber: 1,
          StartRoomNo: "",
          EndRoomNo: ""
        }
      },
      sheet5: false,
      params: {
        WorkID: this.getWork().WorkID,
        SplitProcessID: this.SplitProcessID,
        RadRoomUser: 0,
        FileID: "",
        TableName: "",
        Fields: {
          RoomNo: "",
          UserName: "",
          UserPIN: "",
          Tel: "",
          UserType1: "",
          UserType2: "",
          UserType3: ""
        }
      }
    };
  },
  watch: {
    sheet2content: {
      handler(newVal) {
        //eslint-disable-next-line
        console.log("oldVal,newVal", newVal);
        //判断是否在系统内抽签开关变量为true时,将参数字典中的RoomNo(考场对应字段)内容清除
        if (newVal.isDrawLots == true) this.params.Fields.RoomNo = "";
      },
      deep: true
    }
  },
  props: {
    SplitProcessID: String, //分解环节ID
    ProcessData: Object, //工作环节数据
    ProcessRefresh: Function, //工作环节刷新事件
    completeBtnAttribute: Object //工作环节上报完成按钮
  },
  components: {},
  methods: {
    //上传进度
    //eslint-disable-next-line
    handleProcess(event, file, fileList) {
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "上传" + file.percentage.toFixed(0) + "%"
      });
    },
    //点击已上传的文件链接时的钩子, 可以通过 file.response 拿到服务端返回数据
    handlePreview() {},
    //文件列表移除文件时的钩子
    handleRemove() {},
    //删除文件之前的钩子，参数为上传的文件和文件列表，若返回 false 或者返回 Promise 且被 reject，则停止上传。
    beforeRemove() {},
    //文件超出个数限制时的钩子
    handleExceed() {},
    handleSuccess(response, file, fileList) {
      this.$toast.clear();
      //eslint-disable-next-line
      console.log("文件上传成功返回", response, file, fileList);
      if (response.code == 20000) {
        this.sheet1 = true;
        this.params.FileID = response.data.FileID;
        this.sheet1content.FileID = response.data.FileID;
        this.sheet1content.TableList = response.data.TableList;
      } else {
        // 以弹出框的形式提示异常信息
        this.$dialog
          .alert({ title: "上传文件异常", message: response.message })
          .then(() => {
            // on close
          });
      }
    },
    getTableField(item) {
      //将参数对象表名改为当前选择表
      this.params.TableName = item;
      this.apiMonitorFileFieldGet(
        {
          WorkID: this.getWork().WorkID,
          FileID: this.sheet1content.FileID,
          TableName: item
        },
        this,
        res => {
          //console.log("获取上传文件某个表中的字段", res);
          this.sheet1 = false;
          this.sheet2content.data = res.data;
          this.sheet2 = true;
        }
      );
    },
    setMonirorReportBtn() {
      this.apiMonitorReportPost(this.params, this, res => {
        this.$toast(res.message);
        if (res.code == 20000) {
          this.verifiMonitorIsReport()
          this.sheet2 = false;
          this.params.Fields = {
            RoomNo: "",
            UserName: "",
            UserPIN: "",
            Tel: "",
            UserType1: "",
            UserType2: "",
            UserType3: ""
          };
          /* this.$dialog
            .confirm({
              title: "提示",
              message: "监考员名单导入完成，是否进行抽签"
            })
            .then(() => {
              this.postMonitorDrawlotsmonitorBtn();
              // on confirm
            })
            .catch(() => {
              // on cancel
            }); */
        }
      });
    },
    getMonirorReportBtn() {
      this.apiMonitorReportGet(
        {
          WorkID: this.getWork().WorkID,
          SplitProcessID: this.SplitProcessID
        },
        this,
        res => {
          //eslint-disable-next-line
          console.log("获取监考员信息", res);
          if (res.code == 20000) {
            this.verifiMonitorIsReport();
            if (res.data.length > 0) {
              this.sheet3content.data = res.data;
              this.sheet3content.resultmessage = res.resultmessage;
              this.sheet3 = true;
            } else {
              this.$toast("没有查询到监考员数据");
            }
          }
        }
      );
    },
    putMonitorDrawlotsmonitorBtn(flg) {
      // Flg(int):继承标记1:继承监考员及抽签结果2:继承监考员信息
      var msg = flg == 1 ? "继承监考员及抽签结果" : "继承监考员信息";
      this.$dialog
        .confirm({
          title: "提示",
          message: msg
        })
        .then(() => {
          // on confirm
          this.apiMonitorExportPut(
            {
              WorkID: this.getWork().WorkID,
              SplitProcessID: this.SplitProcessID,
              Flg: flg
            },
            this,
            res => {
              if (res.code == 20000) {
                this.verifiMonitorIsReport();
              }
              this.$toast(res.message);
              this.sheet5 = false;
            }
          );
        })
        .catch(() => {
          // on cancl
        });
    },
    postMonitorDrawlotsmonitorBtn() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确定抽签?"
        })
        .then(() => {
          // on confirm
          this.apiMonitorExportPost(
            {
              WorkID: this.getWork().WorkID,
              SplitProcessID: this.SplitProcessID
            },
            this,
            res => {
              if (res.code == 20000) {
                this.verifiMonitorIsReport();
              }
              this.$toast(res.message);
            }
          );
        })
        .catch(() => {
          // on cancl
        });
    },
    moveMonitorDrawlotsmonitorBtn() {
      this.sheet4 = true;
    },
    moveMonitorDrawlotsmonitorHandleBtn() {
      //移动监考员考场号
      this.$dialog
        .confirm({
          title: "提示",
          message: "移动监考员考场号 ?"
        })
        .then(() => {
          // on confirm
          this.apiMonitorExportMovePut(this.sheet4content.data, this, res => {
            //eslint-disable-next-line
            console.log("移动监考员考场号", res);
            this.$toast(res.message);
          });
        });
    },
    deleteMonirorDrawlotsmonitorBtn() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确定清空抽签结果?"
        })
        .then(() => {
          // on confirm
          this.apiMonitorExportDelete(
            {
              WorkID: this.getWork().WorkID,
              SplitProcessID: this.SplitProcessID
            },
            this,
            res => {
              if (res.code == 20000) {
                this.verifiMonitorIsReport();
              }
              this.$toast(res.message);
            }
          );
        })
        .catch(() => {
          // on cancl
        });
    },
    deleteReportMonirorBtn() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确定删除本场次考试的监考员信息?"
        })
        .then(() => {
          // on confirm
          this.apiMonitorReportDelete(
            {
              WorkID: this.getWork().WorkID,
              SplitProcessID: this.SplitProcessID
            },
            this,
            res => {
              if (res.code == 20000) {
                this.verifiMonitorIsReport();
              }
              this.$toast(res.message);
            }
          );
        })
        .catch(() => {
          // on cancl
        });
    },
    verifiMonitorIsReport() {
      this.completeBtnAttribute.disabled = true;
      //判断监考员数量的方法改为与后端一致，请求apiMonitorReportCount接口
      this.apiMonitorReportCount(
        {
          WorkID: this.getWork().WorkID,
          SplitProcessID: this.$route.params.id
        },
        this,
        res => {
          if (res.code == 20000) {
            //根据返回值判断是否已上传监考名单
            if (res.data == 1) {
              // eslint-disable-next-line no-console
              this.completeBtnAttribute.disabled = false;
            } else {
              // IsPermit 未上传监考员名单是否允许上报： 0不需要，1需要
              if (this.ProcessData.PlugJson.PlugBody.IsPermit == 0) {
                //请完成监考人员名单上传后再进行工作任务上报
                this.completeBtnAttribute.disabled = true;
              } else {
                this.completeBtnAttribute.disabled = false;
              }
            }
          }
        }
      );
    }
  },
  created() {
    this.url = this.apiMonitorFileUrl(); //监考员上传组件地址
    this.header = this.getMonitorlFileParam(); //监考员上传头参数
    this.param = {
      WorkID: this.getWork().WorkID,
      SplitProcessID: this.SplitProcessID
    };
    this.verifiMonitorIsReport();
    this.completeBtnAttribute.tips="需要先导入监考人员信息后上报状态";
  },
  mounted() {}
};
</script>

<style scoped>
</style>
